import { t } from '@lingui/macro';

import type { SortingTypes } from '@decisiv/ui-components/lib/components/Table';
import { Column } from '@decisiv/ui-components/lib/components/Table/types';

import { sortFactory } from 'utils/sortFactory';

import TeamTypeCell from 'pages/Teams/Cells/TeamTypeCell';
import IdCell from 'pages/Teams/Cells/IdCell';

import CreatedAtCell from 'pages/Teams/Cells/CreatedAtCell';
import PlatformAccountsCell from 'pages/Teams/Cells/PlatformAccountsCell';
import EnabledAssetsCell from 'pages/Teams/Cells/EnabledAssetsCell';
import MembersCell from 'pages/Teams/Cells/MembersCell';
import OwnerCell from 'pages/Teams/Cells/OwnerCell';
import ActionsCell from 'pages/Teams/Cells/ActionsCell';
import type { ManagedTeamsType } from '.';

import ApiUserCell from './Cells/ApiUserCell';
import OemSegmentNameCell from './Cells/OemSegmentNameCell';
import TeamNameCell from './Cells/TeamNameCell';
import CreatedByCell from './Cells/CreatedByCell';
import PlatformAccountsCountCell from './Cells/PlatformAccountsCell';

interface GenerateColumnsParams {
  onSort: (fieldName: string, direction: SortingTypes) => void;
}

export const generateColumns = ({ onSort }: GenerateColumnsParams) => {
  return [
    {
      name: 'oemSegmentName',
      title: t`OEM Segment Name`,
      DataCell: OemSegmentNameCell,
      sortBy: sortFactory('OEM_SEGMENT_NAME', onSort),
    },
    {
      name: 'name',
      title: t`Team Name`,
      DataCell: TeamNameCell,
      sortBy: sortFactory('NAME', onSort),
    },
    {
      name: 'id',
      title: t`Team ID`,
      DataCell: IdCell,
      sortBy: sortFactory('ID', onSort),
    },
    {
      name: 'teamType',
      title: t`Team Type`,
      DataCell: TeamTypeCell,
      sortBy: sortFactory('TEAM_TYPE', onSort),
    },
    {
      name: 'createdBy',
      title: t`Created By`,
      DataCell: CreatedByCell,
      sortBy: sortFactory('CREATED_BY_NAME', onSort),
    },
    {
      name: 'createdAt',
      title: t`Created On`,
      DataCell: CreatedAtCell,
      sortBy: sortFactory('CREATED_AT', onSort),
    },
    {
      name: 'platformAccounts',
      title: t`Accounts`,
      DataCell: PlatformAccountsCountCell,
      sortBy: sortFactory('PLATFORM_ACCOUNTS_COUNT', onSort),
    },
    {
      name: 'portalId',
      title: t`Account ID`,
      DataCell: PlatformAccountsCell,
      sortBy: sortFactory('DEALER_GROUP_ID', onSort),
    },
    {
      name: 'assets',
      title: t`Assets`,
      DataCell: EnabledAssetsCell,
      sortBy: sortFactory('ENABLED_ASSET_COUNT', onSort),
    },
    {
      name: 'members',
      title: t`Team Members`,
      DataCell: MembersCell,
      sortBy: sortFactory('MEMBERS_COUNT', onSort),
    },
    {
      name: 'owner',
      title: t`Owner`,
      DataCell: OwnerCell,
      sortBy: sortFactory('OWNER_USERNAME', onSort),
    },
    {
      name: 'apiUsername',
      title: t`API User`,
      DataCell: ApiUserCell,
      sortBy: sortFactory('API_USER', onSort),
    },
    {
      fixed: true,
      name: 'enabled',
      title: t`Status`,
      DataCell: ActionsCell,
    },
  ] satisfies Column<ManagedTeamsType>[];
};
